<script>
import { layoutMethods } from "@/state/helpers";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { reportsMethods, reportsComputed, exportMethods,eloadRewardsComputed,eloadRewardsMethods,erpFixMessages } from "@/state/helpers"
import Swal from 'sweetalert2';
import Multiselect from "vue-multiselect";
import moment from 'moment-timezone';
import { getModuleAccess, showAccessRestrictedModal } from '@/router/helper.js'

/**
 * E-Load list component
 */
export default {
  page: {
    title: "E-Load Rewards"
  },
  data() {
    return {
      searchValue: {
        searchField: null,
        search: "",
        dateRange: null,
        sort: 'id',
        orderDesc: true,
        status: null,
        type: null,
        page: 1,
        rows: 10
      },
      searchList: [
        { text: "Search All", value: null },
        { text: "Event Name", value: "event_name" }
      ],
      rewardLogs: [],
      fields: [
        {
          key: "action",
          sortable: false,
        },
        {
          key: "event_name",
          sortable: true,
        },
        {
          key: "type",
          sortable: true,
        },
        {
          key: "event_date",
          sortable: true,
        },
        {
          key: "total_amount",
          sortable: false,
        },
        {
          key: "requested_by",
          sortable: false,
        },
        {
          key: "department",
          sortable: false,
        },
        {
          key: "approved_by_line_manager",
          sortable: false,
        },
        {
          key: "approved_by_finance",
          sortable: false,
        },
        {
          key: "status",
          sortable: true,
        },
        {
          key: "date_rewarded",
          sortable: true,
        },
      ],
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      sortBy: "value",
      sortDesc: false,
      rangeOptions: {
        mode: "range",
      },
      statusList: [
        { text: 'All', value: null },
        { text: 'Awaiting for Line Manager approval', value: 'am' },
        { text: 'Awaiting for Finance approval', value: 'af' },
        { text: 'Approved', value: 'a' },
        { text: 'Declined', value: 'd' }
      ],
      typeOptions: [
        { name: 'Comp for irate cx', value: 'c' },
        { name: 'Reimbursement', value: 'r' },
        { name: 'Promo', value: 'p' },
        { name: 'Giveaway', value: 'g' },
        { name: 'Sales', value: 's' }
      ],
      eloadLogsTopups: {
        access: {
          create: false,
          read: false,
          update: false,
          delete: false
        }
      }
    };
  },
  components: {
    flatPickr,
    Multiselect,
  },
  computed: {
    ...reportsComputed,
    ...erpFixMessages,
    ...eloadRewardsComputed,
    rows() {
      return this.dataList.length;
    },
  },
  async mounted() {
    this.changeTitle({title: 'Eload Reward Logs'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'} },
        { text: 'Report', to: { name: 'Report'}},
        { text: 'Eload Rewards', to: { name: 'Eload Rewards'}},
      ]
    });
    try {// this will trigger to update the reward status
      var email_action =JSON.parse(localStorage.getItem("email_action")),
          self         = this;
      localStorage.removeItem('email_action');
      switch (email_action["module"]) {
        case "eloadReward":
          await this.rewardApproves(email_action)
          .then(function(res){
              // console.log(":: RES ::",JSON.stringify(res));
              Swal.fire("Eload Reward", `${res.message}`, "success");
              self.searchValue.search = res["eload_reward"]["event_name"]
          })
          .catch(function(e){
              // console.log(":: E ::",JSON.stringify(e));
              Swal.fire("Eload Reward", `${e.message}`, "error");
          });
          break;
      
        default:
          break;
      }
      
    } catch (error) {
      // console.log(">> err:", error)
    }
    var date_today = moment().format('YYYY-MM-DD');
    var date_range = date_today + ' to ' + date_today;
    this.searchValue.dateRange = date_range
    this.onSearch();

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Reports', 'ELoad Transaction Logs', 'Rewards')
        .then((access) => this.eloadLogsTopups.access = access);
  },
  methods: {
    ...layoutMethods,
    ...reportsMethods,
    ...exportMethods,
    ...eloadRewardsMethods,
    async onSearch(state = ''){
        // console.log("onsearch");
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        await this.eloadRewardList(this.searchValue)
        .then(function(res){
          console.log("check:",res);
        })
        .catch(function(e){
            Swal.fire("Loading Failed!", `${e}`, "error");
        });
    },
    tableSort(ctx){//context
      this.searchValue.sort = ctx.sortBy;
      this.searchValue.orderDesc = ctx.sortDesc;
      console.log(">> sorting",this.searchValue);
      this.onSearch('reset');
    },
    async onExport(){
      await this.onSearch("reset");
      if(this.eloadRewardTotalRows ==0){
        Swal.fire("Failed!", this.exportNullPrompt, "warning");
        return;
      }
      // var search_value_holder = this.searchValue;
      let params = Object.assign(
        // this.searchValue,
        {
          module: 'eload_rewards',
          email: JSON.parse(localStorage.getItem('userData')).email,
          dateRange: this.searchValue.dateRange,
          orderDesc: this.searchValue.orderDesc,
          search: this.searchValue.search,
          searchField: this.searchValue.searchField,
          sort: this.searchValue.sort,
          status: this.searchValue.status,
          type: this.searchValue.type
        });

      // delete params.page;
      // delete params.rows;
      
      this.exportReport(params)
        .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
        console.log("value:",this.searchValue,params)
        // this.searchValue = search_value_holder;
    },
    async deleteReward(item){
      if (this.eloadLogsTopups.access.create) {
        Swal.fire({
          title: "Are you sure?",
          text: `Do you really want to delete ${item.event_name}? This process cannot be undone.`,
          icon: "question",
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonColor: "#c4297c",
          cancelButtonColor: "#804997",
          confirmButtonText: "Yes",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await this.actionEloadReward({
                action: "delete",
                body: {event_id:item.id}
            })
            .then((res) => {
                console.log(":: delete ::",res);
                Swal.fire(
                  "Delete Successful!",
                  `${item.event_name} has been deleted.`,
                  "success"
                );
                this.onSearch();
            }).catch((e)=>{
                console.log(":: delete err ::",e);
                // this.$alertify.error(error);
                Swal.fire("Delete Failed!", `An Error Occured: ${e}`, "danger");
                return;
            });
          } else {
            return;
          }
        });
      } else {
        showAccessRestrictedModal();
      }
    },
    async duplicateReward(item){
      this.$router.push(
        this.$route.query.redirectFrom || {
          name: "Eload Add Rewards", 
          params: { id: item.id, action:"copy" }
        }
      );
      /*Swal.fire({
        title: "Are you sure?",
        text: `Do you really want to copy the ${item.event_name} This process cannot be undone!`,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "No",
        confirmButtonColor: "#c4297c",
        cancelButtonColor: "#804997",
        confirmButtonText: "Yes",
      }).then(async (result) => {
        if (result.value) {
          await this.actionEloadReward({
              action: "duplicate",
              body: {event_id:item.id}
          })
          .then((res) => {
              console.log(":: duplicate ::",res);
              Swal.fire(
                "Copy Successful!",
                `${item.event_name} has been copy.`,
                "success"
              );
              this.$router.push(
                this.$route.query.redirectFrom || {
                  name: "Eload Add Rewards", 
                  params: { id: res["message"]["copy_id"], action:"copy" }
                }
              );
              // this.onSearch();
          }).catch((e)=>{
              console.log(":: copy err ::",e);
              // this.$alertify.error(error);
              Swal.fire(
                "Copy Failed!",
                e,
                "warning"
              );
              return;
          });
        }
      });*/
    },
    eventDateFixer(date){
      return moment(date).subtract(8, 'hours')
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <h5 class="card-title">
                    <span class="text-muted fw-normal ms-2">{{eloadRewardTotalRows}}</span>
                    Record(s)
                  </h5>
                </div>
              </div>
              <!-- end col -->
              <div class="col-md-6" style="text-align: right;">
                <router-link :to="{ name: 'Eload Add Rewards', params: { id: 0, action:'new'}}" class="tc-white" v-if="eloadLogsTopups.access.create">
                  <button class="btn btn-primary me-2">
                      <i class="uil uil-plus me-1"></i> Rewards
                  </button>
                </router-link>
                <a href="javascript:void(0);" class="btn btn-primary me-2" @click="onExport">
                  <i class="uil uil-export me-1"></i>
                  Export
                </a>
                <button class="btn btn-secondary" @click="onSearch">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
                </button>
              </div>
              <div class="col-md-12 mt-3"></div>
              <!-- Search and button -->
              <div class="col-md-3 ta-right">
                <b-form-group description="Search Keyword">
                  <form class="d-flex" @submit.prevent="onSearch('reset')">
                    <b-form-group id="input-group-3" label-for="input-3">
                      <b-form-select
                        class="form-select rounded-0 rounded-start shadow-none"
                        id="input-3"
                        v-model="searchValue.searchField"
                        :options="searchList"
                      ></b-form-select>
                    </b-form-group>

                    <b-input-group>
                      <b-form-input
                        class="rounded-0"
                        v-model="searchValue.search"
                      ></b-form-input>
                      <b-input-group-append  v-if="false">
                        <b-button
                          variant="primary"
                          type="submit"
                          class="rounded-0 rounded-end px-2"
                        >
                          <i class="bx bx-search bx-fw"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </form>
                </b-form-group>
              </div>
              <div class="col-md-3 ta-right">
                <b-form-group description="Filter by Type">
                  <multiselect 
                    v-model="searchValue.type" 
                    :options="typeOptions" 
                    :multiple="true" 
                    :close-on-select="false" 
                    :clear-on-select="false" 
                    :preserve-search="true" 
                    placeholder="Select type" 
                    label="name" 
                    track-by="name">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                      <span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} type{{values.length > 1 ? "s":""}}</span>
                    </template>
                  </multiselect>
                </b-form-group>
              </div>
              <div class="col-md-2 ta-right">
                <b-form-group label-for="reward-status" description="Filter by status">
                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                    id="reward-status"
                    v-model="searchValue.status"
                    :options="statusList"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <div
                  class="
                    d-flex
                    flex-wrap
                    align-items-start
                    mt-2 mt-md-0
                    gap-2
                    mb-3 ta-right
                  "
                >
                  <b-form-group description="Filter by date added">
                    <flat-pickr
                      v-model="searchValue.dateRange"
                      :config="rangeOptions"
                      placeholder="Select a date range"
                      class="form-control"
                      style="width: fit-content"
                    ></flat-pickr>
                  </b-form-group>
                  <a class="btn btn-primary h-fit" @click="onSearch('reset')">
                    <i class='bx bx-search bx-fw'></i>Search
                  </a>
                </div>
              </div>
            </div>
            <!-- end col -->
            <!-- end row -->

            <div class="table-responsive">
              <div class="table align-middle table-nowrap text-capitalize">
                <b-table
                  :items="eloadRewards"
                  :fields="fields"
                  responsive="sm"
                  :current-page="searchValue.page"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  class="table-check"
                  @sort-changed="tableSort"
                >
                  <template #cell(action)="data">
                    <div class="" v-if="data.item.status =='dr'">
                      <router-link :to="{ name: 'Eload Add Rewards', params: { id: data.item.id, action:'edit' }}" class="tc-white">
                        <b-button variant="primary" class="p-1 mr-2"><i class="bx bx-edit bx-xs bx-fw"></i></b-button>
                      </router-link>
                      <b-button variant="danger" class="p-1" @click="deleteReward(data.item)"><i class="bx bx-trash bx-xs bx-fw"></i></b-button>
                    </div>
                    <div class="" v-if="data.item.status =='d'">
                      <b-button variant="secondary" class="p-1" @click="duplicateReward(data.item)"><i class="bx bx-copy-alt bx-xs bx-fw"></i></b-button>
                    </div>
                  </template>
                  <template #cell(event_name)="data">
                    <router-link :to="{ name: 'Eload View Rewards', params: { id: data.item.id }}" :class="{ 'recent' : $route.query.rewardId == data.item.id }"> 
                      {{data.item.event_name}}
                    </router-link>
                  </template>
                  <template #cell(total_amount)="data">
                    <p class="text-body text-end m-0">
                      PHP {{ data.item.total_amount | toCurrency }}
                    </p>
                  </template>
                  <template #cell(event_date)="data">
                    <p class="text-body text-end m-0">
                      {{ eventDateFixer(data.item.event_date) | formatDate }}
                    </p>
                  </template>
                  <template #cell(type)="data">
                    {{ data.item.type_full }}
                  </template>
                  <template #cell(status)="data">
                    <span 
                      :class="`${data.item.status == 'am' ||data.item.status == 'af' ?  'text-danger': (data.item.status == 'a'?'text-success':'text-muted')}`">
                      {{ data.item.status_full }}
                    </span>
                  </template>
                  <template #cell(date_rewarded)="data">
                    <p class="text-body text-end m-0">
                      {{ data.item.date_rewarded | formatDate }}
                    </p>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="eloadRewardTotalRows == 0">
              <!-- topupLogsTotalRows == 0 -->
              <span>No data to display.</span>
            </div>
            <div class="row" v-if="eloadRewardTotalRows > 0">
              <div class="col">
                <div class="form-group row pull-left">
                  <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                  <div class="col-sm-6">
                    <b-form-group label-for="display-record">
                      <b-form-select class="form-select shadow-none w-fit"
                        id="display-record"
                        v-model="searchValue.rows"
                        :options="pageOptions"
                        @change="onSearch('reset')"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                </div>
                <div
                  class="
                    dataTables_paginate
                    paging_simple_numbers
                    float-end
                  "
                >
                  <b-pagination
                    v-if="eloadRewardTotalRows != 0 && eloadRewardTotalRows > searchValue.rows"
                    class="pagination-rounded"
                    v-model="searchValue.page"
                    :total-rows="eloadRewardTotalRows"
                    @input="onSearch()"
                    :per-page="searchValue.rows"
                  ></b-pagination>
                </div>
              </div>
            </div>
            
          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>
<style>
.custom-checkbox-method label {margin-left: 10px;}
.custom-checkbox-method input {margin-left: 15px;}
.required-input {color:red;}
.calendar-icon {display: block;font-size: 20px;padding: 8px;background-color: grey;}
.mr-2{
  margin-right: 10px;
}

tr:has(a.recent) {
  font-weight: bold !important;
}
</style>